
<template>
  <BreadCrumb PageTitle="Proxy Stock" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <StockContent />
    </div>
  </div>
</template>

<script setup>

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import StockContent from "../../components/Admin/Proxy/StockContent.vue";

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>